<template>
  <div>
    <div class="laranja">
      <h2>Ainda não é um associado?</h2>
      <p>Ao estar vinculado à Rede de Estudos Rurais, o associado:</p>
      <ol>
        <li>Fará parte de uma Rede de pesquisadores e estudiosos das temáticas rurais;</li>
        <li>Poderá propor Grupos de Trabalho para o Encontro Bienal (as proposições deverão se ajustar às regras definidas no edital do evento);</li>
        <li>Terá desconto na inscrição do Encontro Bienal;</li>
        <li>Poderão (Orientador e Orientando) concorrer ao Prêmio Nazaré Baudel Wanderley de melhor tese. </li>
      </ol>
      <span v-if="!showLink">
      <p>Os valores para 2022 e 2023 por categoria são:</p>
      <ul>
        <li>PROFISSIONAIS:  R$ 200,00</li>
        <li>ESTUDANTES: R$ 120,00 </li>
      </ul>
      <p>Ou promocional biênio:</p>
      <ul>
        <li>PROFISSIONAIS:  R$ 350,00</li>
        <li>ESTUDANTES: R$ 200,00 </li>
      </ul>
      </span>
      <p class="text-center" v-if="showLink">
        <router-link to="/register">Seja um associado!</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColunaSocio",
  props: {
    showLink: Boolean
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
